<template>
  <div>
    <b-row class="justify-content-md-center mb-3">
      <b-col class="bread-crumbs">
        <span class="redirect" v-on:click="redirect('Dashboard')">Dashboard</span>
        <span class="arrow">></span>
        <span class="redirect" v-on:click="redirect('WorkOrders')">Work orders</span>
        <span class="arrow">></span>
        <span class="active">{{user.first_name}} {{user.last_name}}</span>
      </b-col>
    </b-row>
    <details-user
        type="workers"/>
  </div>
</template>

<script>
import DetailsUser from '../../components/common/DetailsUser.vue';
import store from '../../store/index';
async function getUser(id) {
    store.dispatch('workers/details',id);
}
export default {
    name: "WorkersDetail",
    async beforeRouteEnter(to, from, next) {
        getUser(to.params.id);
        next();
    },
    async beforeRouteUpdate(to, from, next) {
        getUser(to.params.id);
        next();
    },
    components: {
        DetailsUser
    },
    computed: {
        user() {
            return this.$store.state.workers.details;
        },
    },
    data() {
        return {
        };
    },
    methods: {
      redirect(name){            
        this.$router.push({ name: name });
      }
    },
};
</script>
<style  scoped>
</style>